import { Link } from 'react-router-dom';

import { PrimaryButton } from "../../components/button/Button";

import './errorPages.css'
import React from "react";

const PageNotFound = () => {
    return (
        <div className="error-page">
            <h1>404</h1>
            <h2>Page Not Found</h2>
            <p>The page you are looking for doesn't exist or has been moved.</p>
            <PrimaryButton>
                <Link to="/home">
                    Go to Homepage
                </Link>
            </PrimaryButton>
        </div>
    );
};

export default PageNotFound;